export default __webpack_public_path__ + "static/media/toy1.6a56f675.jfif";